export function withAdminPreviewParam(url: string | null | undefined, variantId?: string | null): string {
  if (!url) return '';

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const parsed = new URL(url, base);
    parsed.searchParams.set('ef_admin', '1');
    if (variantId) {
      parsed.searchParams.set('ef_variant', variantId === '__control__' ? 'control' : variantId);
    }

    if (!/^[a-z][a-z0-9+.-]*:/i.test(url)) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    return parsed.toString();
  } catch {
    const separator = url.includes('?') ? '&' : '?';
    const variantParam = variantId ? `&ef_variant=${encodeURIComponent(variantId === '__control__' ? 'control' : variantId)}` : '';
    return `${url}${separator}ef_admin=1${variantParam}`;
  }
}
